import BrowserHistoryHandler from '../../infrastructure/adapter/BrowserHistoryHandler';

export class HistoryHandlerUsecase {
  private browserHistoryHandler: BrowserHistoryHandler;

  constructor({ browserHistoryHandler }: { browserHistoryHandler: BrowserHistoryHandler }) {
    this.browserHistoryHandler = browserHistoryHandler;
  }

  public replaceHistory(selectedOrganizationId: string) {
    let pathname = '';
    if (selectedOrganizationId) {
      pathname = `/organizations/${selectedOrganizationId}`;
    }
    this.browserHistoryHandler.replace(pathname);
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/application/usecase/HistoryHandlerUsecase.ts